var base = require('settings/api');

Vue.component('spark-api', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/api.js